import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { queryPersonaChats } from '@wix/ambassador-legends-persona-v1-chat/http';
import {
  ChatMode,
} from '@wix/ambassador-legends-persona-v1-chat/types';
import { shouldReportErrorMonitor } from '../../Challenge/helpers/shouldReportErrorMonitor';
import { handleError } from '../../../ErrorHandler/errorHandlerPropsMap';
import { EDUCATION_NAMESPACE } from '../consts';
import { request } from '../../../../services/request';

export default async function (
  flowAPI: ControllerFlowAPI,
  personaId: string,
): Promise<string | null> {
  try {
    const queryRecentChatIdTransaction = flowAPI.panoramaClient.transaction(
      'query-recent-chat-id',
    );

    queryRecentChatIdTransaction.start();

    const response = await request({
      flowAPI,
      options: queryPersonaChats({
        namespaceV2: EDUCATION_NAMESPACE,
        personaId,
        query: {
          filter: {
            mode: ChatMode.PUBLISHED,
          },
          cursorPaging: {
            limit: 1,
          },
        },
      }),
      errorOptions: {
        errorCodesMap: {
          applicationError: {},
        },
      },
    });

    queryRecentChatIdTransaction.finish();

    const chatId = response?.data?.chats[0]?.id;
    return chatId;
  } catch (error) {
    const resolvedError = flowAPI.errorHandler.getResolvedError(error);

    handleError({
      error,
      resolvedError,
      context: 'QueryRecentChat',
      preventErrorMonitorReport: !shouldReportErrorMonitor(error),
    });

    return null;
  }
}
